import { toast as hotToast, type ToastOptions } from 'react-hot-toast';

// Re-export Toaster primitives so __root.tsx (the one legitimate call site that renders
// the Toaster) doesn't need to import directly from react-hot-toast.
export { Toaster, ToastBar, useToaster } from 'react-hot-toast';

const defaults: ToastOptions = { duration: 4000 };

export const toast = {
  success: (message: string, options?: ToastOptions) =>
    hotToast.success(message, { ...defaults, ...options }),
  error: (message: string, options?: ToastOptions) =>
    hotToast.error(message, { ...defaults, ...options }),
};
